import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Activity, Lock } from "lucide-react";
import { toast } from "sonner";

function formatErr(detail) {
  if (!detail) return "Login failed. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) nav("/admin");
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-dark grid-lines flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2.5 mb-10">
          <span className="grid place-items-center w-9 h-9 bg-orange text-white"><Activity className="w-5 h-5" strokeWidth={2.5} /></span>
          <span className="font-display font-extrabold text-lg tracking-tight">ATHLETIC<span className="text-teal">DATA</span></span>
        </Link>

        <form data-testid="admin-login-form" onSubmit={submit} className="bg-dark-surface border border-white/10 p-8">
          <div className="flex items-center gap-2 mb-8">
            <Lock className="w-4 h-4 text-teal" />
            <h1 className="font-display text-2xl font-black uppercase tracking-tighter">Admin Access</h1>
          </div>
          <div className="space-y-5">
            <div className="space-y-2">
              <Label className="font-mono text-xs uppercase tracking-widest text-slate-400">Email</Label>
              <Input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                className="bg-dark border-white/15 text-white h-12 rounded-none focus-visible:ring-teal focus-visible:ring-1" placeholder="admin@athleticdata.com" />
            </div>
            <div className="space-y-2">
              <Label className="font-mono text-xs uppercase tracking-widest text-slate-400">Password</Label>
              <Input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                className="bg-dark border-white/15 text-white h-12 rounded-none focus-visible:ring-teal focus-visible:ring-1" placeholder="••••••••" />
            </div>
            <button data-testid="admin-login-submit" disabled={loading}
              className="w-full bg-teal text-black py-3.5 font-display font-bold uppercase tracking-wide hover:bg-teal-muted transition-colors duration-300 disabled:opacity-60">
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
